import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Anchor, PageContentWrapper, PageModal } from 'UI-Dash-Commons-UI';

const RedirectModalComponent: React.FunctionComponent = () =>
{
    useEffect(() => {
        const timeout = setTimeout(() => {
            window.location.href = 'https://ads.axon.ai';
        }, 5000);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <PageModal isVisible={true} closeModal={() => {}} width={'70vw'} showCloseButton={false}>
            <PageContentWrapper>
                <Header>Dash is deprecated</Header>
                <Text>
                    This dash is now deprecated. Please use our new Ads Manager at <StyledAnchor href="https://ads.axon.ai" text="ads.axon.ai" target="_blank" />. You can use your existing AppLovin credentials to log in.
                </Text>
                <Text>
                    You will now be redirected to the Ads Manager.
                </Text>
            </PageContentWrapper>
        </PageModal>
    );
};

export default RedirectModalComponent;

const Header = styled.h1`
    font-family: "AL-AvenirNext-DemiBold", sans-serif;
    font-size: 30px;
    font-weight: bold;
    margin-top: 0;
`;

const Text = styled.p`
    font-family: "AL-AvenirNext-Regular", sans-serif;
`;

const StyledAnchor = styled(Anchor)`
    font-size: 16px;
`;
